import React from 'react';
import cerebro from 'assets/images/cerebro-1.png';
import elem1 from 'assets/images/red-elem1.png';
import elem2 from 'assets/images/red-elem2.png';
import elem4 from 'assets/images/red-elem4.png';
import elem5 from 'assets/images/red-elem5.png';
import elem6 from 'assets/images/red-elem6.png';
import elem7 from 'assets/images/red-elem7.png';
import { Link } from 'react-router-dom';

export default function RicoData() {
  return (
    <div className='red'>
      <div className="logo">
        <h3>Rico en Data</h3>
      </div>
      <figure>
        <img src={cerebro} alt="Imagen de cerebro" />
      </figure>
      <figcaption>
        <p>Ahora la educación financiera llega<br />a las aulas bonaerenses</p>
        <Link className="btn-verde" to="/rico-en-data">Conocé más</Link>
      </figcaption>
      <div className="elems">
        <img src={elem1} className='elem elem1' alt="" />
        <img src={elem2} className='elem elem2' alt="" />
        <img src={elem2} className='elem elem2b' alt="" />
        <img src={elem2} className='elem elem2c' alt="" />
        <img src={elem4} className='elem elem4' alt="" />
        <img src={elem5} className='elem elem5' alt="" />
        <img src={elem5} className='elem elem5b' alt="" />
        <img src={elem5} className='elem elem5c' alt="" />
        <img src={elem6} className='elem elem6' alt="" />
        <img src={elem7} className='elem elem7' alt="" />
      </div>
    </div>
  );
}